import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-user-affiliate-order-list-card',
  templateUrl: './user-affiliate-order-list-card.component.html',
  styleUrls: ['./user-affiliate-order-list-card.component.scss'],
})
export class UserAffiliateOrderListCardComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  displayedColumns: string[] = [
    'paid_time',
    'name',
    'platform',
    'commission',
    'commission_status',
  ];
  constructor(private api: UserApiService, private message: MessageService) {}

  loading = false;
  page = 0;
  pageSize = 10;
  total = 0;
  orders: any[] = [];

  ngOnInit(): void {
    this.paginator._intl.itemsPerPageLabel = '每页显示';
    this.findUserAffiliateOrders();
  }

  async findUserAffiliateOrders() {
    try {
      this.loading = true;
      const r = await this.api.findUserAffiliateUserOrder(
        0,
        this.page + 1,
        this.pageSize
      );
      const data = r.data;
      this.page = data.page - 1;
      this.pageSize = data.page_size;
      this.total = data.total;
      this.orders = data.list;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  onPageChange(e: any) {
    console.log(e);
    this.page = e.pageIndex;
    this.pageSize = e.pageSize;
    this.findUserAffiliateOrders();
  }
}
